<template>
    <div class="blank">
        <div class="blank-image" v-if="imgSrc">
            <figure class="image image-128">
                <img :src="imgSrc">
            </figure>
        </div>
        <div class="blank-content">
            <h2 class="blank-title">
                <slot name="title"/>
            </h2>
            <p class="blank-description">
                <slot name="description"/>
            </p>
            <div class="blank-actions">
                <slot name="actions"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'v-no-content',
        props: {
            imgSrc: {
                type: String,
                default: '/static/icons/blank-state/create-blank-state-icon.svg',
            },
        },
    };
</script>
